/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate ideal body weight from height with the classic formulas.`)
};

const es_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima el peso corporal ideal a partir de la altura con las fórmulas clásicas.`)
};

const de_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätze das Idealgewicht anhand der Körpergröße mit den klassischen Formeln.`)
};

const nl_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat het ideale lichaamsgewicht op basis van lengte met de klassieke formules.`)
};

const fr_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez le poids corporel idéal à partir de la taille avec les formules classiques.`)
};

const it_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima il peso corporeo ideale dall'altezza con le formule classiche.`)
};

const pt_br2_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o peso corporal ideal a partir da altura com as fórmulas clássicas.`)
};

const pt_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o peso corporal ideal a partir da altura com as fórmulas clássicas.`)
};

const ja_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`古典的な計算式を使って身長から理想体重を推定します。`)
};

const zh_iw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用经典公式根据身高估算理想体重。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_tool_description", locale)
	if (locale === "en") return en_iw_tool_description(inputs)
	if (locale === "es") return es_iw_tool_description(inputs)
	if (locale === "de") return de_iw_tool_description(inputs)
	if (locale === "nl") return nl_iw_tool_description(inputs)
	if (locale === "fr") return fr_iw_tool_description(inputs)
	if (locale === "it") return it_iw_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_iw_tool_description(inputs)
	if (locale === "pt") return pt_iw_tool_description(inputs)
	if (locale === "ja") return ja_iw_tool_description(inputs)
	return zh_iw_tool_description(inputs)
};